<template>
  <div class="country-fix-right" :style="{transform: `translateY(${-fixedTransformY}px)`}">
    <!-- <chatvisa-entrance-float
      :visa_country_id="visa_country_id"
      :sensor-data="{
        visa_country_id: visa_country_id,
        source: '国家页',
        country: countryInfo.country
      }"
    ></chatvisa-entrance-float> -->
    <div class="peer-to-wxa" v-if="User.isLogin()">
      <div class="title">微信扫码下单</div>
      <div class="img-box"><img class="wxa-img" v-if="codeUrl" :src="codeUrl" /></div>
    </div>
  </div>
</template>

<script>
import ChatvisaEntranceFloat from '../../chat-visa/component-external/chatvisa-entrance-float.vue';
import User from '@/libs/user';
import wxUtils from '@/libs/wx-utils';

export default {
  components: {
    ChatvisaEntranceFloat,
  },
  props: {
    countryInfo: Object,
    visa_country_id: Number,
    productList: Array,
  },
  data() {
    return {
      User,
      codeUrl: '',
      fixedTransformY: 0, // 主要为了不被footer元素滚动
    };
  },
  computed: {},
  watch: {
    productList() {
      this.handleScroll();
    },
  },
  created() {
    if (User.isLogin()) {
      this.getWxacode();
    }
  },
  mounted() {
    this.handleScroll();

    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    getWxacode() {
      wxUtils.getCountryWxaCode(this.visa_country_id, User.peer_account_id)
        .then((base64) => {
          this.codeUrl = base64;
        })
        .catch((e) => {
          if (e) console.log(e);
        });
    },
    handleScroll() {
      const footerEl = document.querySelector('#footer');
      const rect = footerEl.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      // footer露出的高度，在加上页面底部的多余空白高度
      const fixedTransformY = Math.max(0, viewportHeight - rect.top + 44);
      this.fixedTransformY = fixedTransformY;
    },
  },
};
</script>

<style lang="less" scoped>

.country-fix-right{
  position: fixed;
  bottom: 16px;
  width: 106px;
  // 让浮窗位置固定在离主体内容区右侧外面 20px 的位置
  // 主体内容区宽度 1000px，浮窗宽度 106px，浮窗距离左侧主体内容区 20px
  right: calc(~'(100% - 1120px) / 2 - 126px');
  z-index: 1005;
  display: flex;
  flex-direction: column;
  align-items: center;
  .peer-to-wxa {
    margin-top: 20px;
    padding-top: 4px;
    width: 106px;
    height: 120px;
    background: #fff;
    display: flex;
    flex-flow: column;
    align-items: center;
    line-height: 1;
    border-radius: 3px;
    border: 2px solid #6FACFF;
    .title {
      font-size: 12px;
      color: #2F333D;
      text-align: center;
    }
    .img-box {
      margin-top: 4px;
      width: 95px;
      height: 95px;
      display: flex;
      justify-content: center;
      align-items: center;
      .wxa-img {
        width: 95px;
        height: 95px;
      }
    }
  }
}

/* 媒体查询：当屏幕宽度小于 1500px 时，隐藏目标元素 */
@media (max-width: 1499px) {
  .country-fix-right {
    visibility: hidden;
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/country/components/country-fix-right.vue